import { GeneralAlertEmailLog } from '@/contracts/AlertEmailLogs';
import { SortableHeader, SortableHeadersGroup } from 'components/Shared';
import { parseISO, format } from 'date-fns';
import { SortingParams } from 'contracts/Common';
import React, { useCallback } from 'react';
import * as S from './styles';

interface Props {
  alerts: GeneralAlertEmailLog[];
  onSort?: (sort: SortingParams) => void;
  currentSort: SortingParams;
}

interface ItemProps {
  alert: GeneralAlertEmailLog;
}

export const EmailLogList: React.FC<Props> = ({
  alerts,
  onSort,
  currentSort,
}) => {
  const Item = useCallback(({ alert }: ItemProps): JSX.Element => {
    const { id, subject, receivers, created_at } = alert;

    return (
      <S.ListItem>
        <S.Column>{id}</S.Column>
        <S.Column>{subject}</S.Column>
        <S.Column>{receivers}</S.Column>
        <S.Column>
          {format(parseISO(created_at), 'dd/MM/yyyy HH:mm')}
        </S.Column>
        <S.ActionsColumn>
          <S.LinkActionButton to={`/configuracoes/historico-alertas/${id}`}>
            <S.EditIcon />
          </S.LinkActionButton>
        </S.ActionsColumn>
      </S.ListItem>
    );
  }, []);

  return (
    <S.List>
      <S.ListHeader>
        <SortableHeadersGroup onSort={onSort} currentSort={currentSort}>
          <SortableHeader column="id" label="ID" />
          <SortableHeader column="subject" label="ASSUNTO" />
          <SortableHeader column="receivers" label="DESTINATÁRIOS" />
          <SortableHeader column="created_at" label="DATA" />
        </SortableHeadersGroup>
      </S.ListHeader>

      {alerts.map((alert) => (
        <Item key={alert.id} alert={alert} />
      ))}
    </S.List>
  );
};